// Store initial URL state to detect if variant was in URL on page load
let initialUrlHasVariant = null;

const updateProductGallery = (variant) => {
  const firstImageContainers = document.querySelectorAll('[data-first-image-container]');
  if (!firstImageContainers.length) return;

  // Store initial URL state on first call
  if (initialUrlHasVariant === null) {
    const initialUrl = new URL(window.location.href);
    initialUrlHasVariant = initialUrl.searchParams.has('variant');
  }

  const updateProductGallerySettingsEl = document.querySelector('[data-gallery-update-swiper-on-change]');
  const updateSwiper = updateProductGallerySettingsEl !== null;
  const getImageSrc = (src) => {
    if (!src) return src;
    if (src.startsWith('//')) return window.location.protocol + src;
    if (src.startsWith('/')) return window.location.origin + src;
    return src;
  };

  const getImageUrl = (src, width) => {
    const url = new URL(src);
    if (width) url.searchParams.set('width', width);
    return url.toString();
  };

  const getSrcsetWidths = (srcset) => srcset
    .split(',')
    .map(candidate => candidate.trim().match(/\s(\d+)w$/)?.[1])
    .filter(Boolean);

  const updateImageSrcset = (imageEl, src) => {
    if (!imageEl.hasAttribute('srcset')) return;

    const widths = getSrcsetWidths(imageEl.getAttribute('srcset'));
    if (!widths.length) return;

    const srcset = widths
      .map(width => `${getImageUrl(src, width)} ${width}w`)
      .join(', ');

    imageEl.setAttribute('srcset', srcset);
  };


  // Future variant gallery hook:
  // Replace this single featured-image swap with a full slide/thumb rebuild once the
  // source is confirmed: variant image-list metafield or labelled product media.

  // Only update if variant has a featured_image
  if (!variant || !variant.featured_image || !variant.featured_image.src) return;

  const imageURL = variant.featured_image.src;
  const formattedImageURL = getImageSrc(imageURL);
  firstImageContainers.forEach((container) => {
    const imageEl = container.querySelector('img');
    if (imageEl) {
      const currentSrc = imageEl.getAttribute('src');
      if (currentSrc === formattedImageURL) return;

      imageEl.setAttribute('src', getImageUrl(formattedImageURL, imageEl.getAttribute('width')));
      updateImageSrcset(imageEl, formattedImageURL);
      if (variant.featured_image?.alt) imageEl.setAttribute('alt', variant.featured_image.alt);
    }
  });
};

export default updateProductGallery;
